import type { AxiosError } from 'axios';

/** Falha de rede ou resposta 5xx — candidata a tela global de servidor. */
export function isServerOrNetworkError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;

  const axiosError = error as AxiosError;
  const status = axiosError.response?.status;

  if (typeof status === 'number' && status >= 500) {
    return true;
  }

  const code = axiosError.code;
  if (code === 'ERR_NETWORK' || code === 'ECONNABORTED') {
    return true;
  }

  if (!axiosError.response && typeof axiosError.message === 'string') {
    return /network/i.test(axiosError.message);
  }

  return false;
}
